export const SET_SEARCH_OPEN_VISIBILITY = 'SET_SEARCH_OPEN_VISIBILITY';
export const SET_SEARCH_CLOSE_VISIBILITY = 'SET_SEARCH_CLOSE_VISIBILITY';
export const SET_INPUT_SEARCH = 'SET_INPUT_SEARCH';
export const SET_SEARCH_DETAILS = 'SET_SEARCH_DETAILS';
export const CLEAR_SUGGESTION = 'CLEAR_SUGGESTION';
